import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class CapacityRoadmapQuerySelectorComponent extends Component {
  @service roadmap;

  @tracked showDropdown = false;

  @action isSelected(roadmap) {
    if (this.args.isAll) return false;
    return this.roadmap.id == roadmap.id;
  }

  @action
  toggleDropdown(val) {
    if (val === undefined) this.showDropdown = !this.showDropdown;
    else this.showDropdown = val;
  }

  @action
  setRoadmap(roadmap) {
    this.roadmap.setId(roadmap.id);
  }

  @action
  handleRoadmapSelect(roadmap) {
    if (roadmap === 'all');
    else {
      this.setRoadmap(roadmap);
      this.toggleDropdown(false);
    }
    this.args?.propagateRoadmapSelect?.(roadmap);
  }
}
